(function () {
  'use strict';

  var REQUEST_TIMEOUT = 8000;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#096;');
  }

  function pluralCategory(label, count) {
    if (count === 1 || /(?:jeans|trousers|shorts|leggings|clothes)$/i.test(label)) return label;
    if (/[^s]s$/i.test(label)) return label;
    if (/[^aeiou]y$/i.test(label)) return label.slice(0, -1) + 'ies';
    if (/(?:s|x|z|ch|sh)$/i.test(label)) return label + 'es';
    return label + 's';
  }

  function cardRenderer() {
    return window.PrewornProductCards || null;
  }

  function sectionFor(grid) {
    return grid.closest('[data-section-id]');
  }

  function departmentFocus(section) {
    if (!section || typeof section.getAttribute !== 'function') return '';
    var value = String(section.getAttribute('data-department-focus') || '').trim();
    if (/^(?:Womens|Mens|Kids)$/.test(value)) return value;

    // Keep the department pages isolated even if a copied section loses its
    // setting in the theme editor. The canonical landing-page path remains an
    // unambiguous fallback; the homepage deliberately returns no focus.
    var pathname = window.location && window.location.pathname
      ? String(window.location.pathname).toLowerCase().replace(/\/+$/, '')
      : '';
    if (/\/pages\/womens?$/.test(pathname)) return 'Womens';
    if (/\/pages\/mens?$/.test(pathname)) return 'Mens';
    if (/\/pages\/(?:kids|children)$/.test(pathname)) return 'Kids';
    return '';
  }

  function departmentSearchValue(section) {
    var department = departmentFocus(section);
    if (department === 'Womens') return 'Women,Womens';
    if (department === 'Mens') return 'Men,Mens';
    if (department === 'Kids') return 'Girls,Boys';
    return '';
  }

  function filterTarget(grid) {
    var section = sectionFor(grid);
    return section ? section.querySelector('[data-pwhome-new-in-filters]') : null;
  }

  function departmentTarget(grid) {
    var section = sectionFor(grid);
    return section ? section.querySelector('[data-pwhome-new-in-departments]') : null;
  }

  function moreTarget(grid) {
    var section = sectionFor(grid);
    return section ? section.querySelector('[data-pwhome-new-in-more]') : null;
  }

  function compactCount(value) {
    var count = Math.max(0, Number(value) || 0);
    if (count >= 1000) {
      var shortCount = count >= 10000 ? Math.round(count / 1000) : Math.round(count / 100) / 10;
      return String(shortCount).replace(/\.0$/, '') + 'K';
    }
    return count.toLocaleString('en-GB');
  }

  function fallbackProducts(grid) {
    var section = sectionFor(grid);
    var data = section ? section.querySelector('[data-pwhome-new-in-fallback]') : null;
    if (!data) return [];

    try {
      var products = JSON.parse(data.textContent || '[]');
      return Array.isArray(products) ? products : [];
    } catch (error) {
      console.warn('[Preworn Home] Shopify fallback data could not be read.', error);
      return [];
    }
  }

  function renderProducts(grid, products, source, append) {
    var renderer = cardRenderer();
    if (!renderer || !products.length) return false;

    var markup = renderer.renderList(products);
    if (append && typeof grid.insertAdjacentHTML === 'function') {
      grid.insertAdjacentHTML('beforeend', markup);
    } else {
      grid.innerHTML = markup;
    }
    renderer.bindWishlist(grid);
    grid.setAttribute('data-source', source);
    return true;
  }

  function renderHeroCount(grid, summary) {
    var section = sectionFor(grid);
    var target = section ? section.querySelector('[data-pwhome-new-in-hero-count]') : null;
    if (!target || !summary) return;
    var state = grid._prewornNewInState;
    var activeDepartment = state ? state.department : departmentFocus(section);
    var total = activeDepartment
      ? departmentCount(summary, activeDepartment)
      : Math.max(0, Number(summary.totalCount) || 0);
    target.textContent = compactCount(total);
    var badge = target.parentNode;
    if (badge && typeof badge.setAttribute === 'function') {
      badge.setAttribute(
        'aria-label',
        total.toLocaleString('en-GB') + ' ' +
          (activeDepartment ? activeDepartment + ' ' : '') +
          'new products in the latest listing week'
      );
    }
  }

  function updateLoadMore(grid) {
    var state = grid._prewornNewInState;
    var target = moreTarget(grid);
    if (!state || !target) return;
    var button = target.querySelector('[data-pwhome-new-in-load-more]');
    var loaded = target.querySelector('[data-pwhome-new-in-loaded]');
    var total = target.querySelector('[data-pwhome-new-in-total]');
    if (loaded) loaded.textContent = Math.min(state.loaded, state.total).toLocaleString('en-GB');
    if (total) total.textContent = state.total.toLocaleString('en-GB');
    if (button) {
      button.disabled = state.loading;
      button.setAttribute('aria-busy', state.loading ? 'true' : 'false');
    }
    target.hidden = !state.hasNextPage;
  }

  function renderFilterSelection(target, selected) {
    if (!target) return;
    var buttons = target.querySelectorAll('[data-pwhome-new-in-category]');
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute('data-pwhome-new-in-category') === selected;
      buttons[i].classList.toggle('is-active', active);
      buttons[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function renderDepartmentSelection(target, selected) {
    if (!target) return;
    var buttons = target.querySelectorAll('[data-pwhome-new-in-department]');
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute('data-pwhome-new-in-department') === selected;
      buttons[i].classList.toggle('is-active', active);
      buttons[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function departmentCount(summary, department) {
    if (!summary || !Array.isArray(summary.departments)) return 0;
    if (department === 'Kids') {
      return summary.departments.reduce(function (total, item) {
        var value = String(item && item.value || '');
        return total + (/^(?:Girls|Boys)$/.test(value)
          ? Math.max(0, Number(item.count) || 0) : 0);
      }, 0);
    }
    for (var i = 0; i < summary.departments.length; i++) {
      if (String(summary.departments[i].value || '') === department) {
        return Math.max(0, Number(summary.departments[i].count) || 0);
      }
    }
    return 0;
  }

  function activateDepartmentButton(grid, button) {
    if (!grid || !grid._prewornNewInState) return;
    var department = button.getAttribute('data-pwhome-new-in-department') || '';
    if (department === grid._prewornNewInState.department &&
        grid._prewornNewInState.category === '') return;
    requestLatestProducts(grid, department, '', true);
  }

  function bindDepartmentButtons(grid, target) {
    if (!target || target._prewornDepartmentReady) return;
    target._prewornDepartmentReady = true;
    var buttons = target.querySelectorAll('[data-pwhome-new-in-department]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (event) {
        event.stopPropagation();
        activateDepartmentButton(grid, this);
      });
    }
  }

  function renderDepartments(grid, summary) {
    var target = departmentTarget(grid);
    if (!summary) return;
    var controls = sectionFor(grid);
    if (!controls) return;
    var state = grid._prewornNewInState;
    var selected = state ? state.department : '';
    var buttons = controls.querySelectorAll('[data-pwhome-new-in-department]');

    for (var i = 0; i < buttons.length; i++) {
      var department = buttons[i].getAttribute('data-pwhome-new-in-department') || '';
      var count = department
        ? departmentCount(summary, department)
        : Math.max(0, Number(summary.totalCount) || 0);
      var countTargets = buttons[i].querySelectorAll('[data-pwhome-new-in-department-count]');
      for (var j = 0; j < countTargets.length; j++) {
        countTargets[j].textContent = count.toLocaleString('en-GB');
      }
      buttons[i].disabled = department !== '' && count < 1;
      buttons[i].setAttribute(
        'aria-label',
        (department || 'All') + ' new in, ' + count.toLocaleString('en-GB') +
          (count === 1 ? ' product' : ' products')
      );
    }

    renderDepartmentSelection(controls, selected);
    renderHeroCount(grid, summary);
    if (target) target.hidden = false;
    bindDepartmentButtons(grid, controls);
  }

  function bindFilterRail(target) {
    if (!target || target._prewornDragReady || typeof target.addEventListener !== 'function') return;
    target._prewornDragReady = true;

    var pressed = false;
    var dragged = false;
    var pointerId = null;
    var startX = 0;
    var startLeft = 0;

    target.addEventListener('pointerdown', function (event) {
      if ((event.pointerType && event.pointerType !== 'mouse') || event.button !== 0) return;
      pressed = true;
      dragged = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startLeft = target.scrollLeft;
    });

    target.addEventListener('pointermove', function (event) {
      if (!pressed || event.pointerId !== pointerId) return;
      var distance = event.clientX - startX;
      if (!dragged && Math.abs(distance) < 10) return;
      if (!dragged) {
        dragged = true;
        if (typeof target.setPointerCapture === 'function') {
          try { target.setPointerCapture(pointerId); } catch (error) {}
        }
      }
      if (target.classList) target.classList.add('is-dragging');
      target.scrollLeft = startLeft - distance;
      event.preventDefault();
    });

    function release(event) {
      if (!pressed || (event.pointerId != null && event.pointerId !== pointerId)) return;
      if (dragged) target._prewornSuppressClickUntil = Date.now() + 350;
      pressed = false;
      dragged = false;
      if (target.classList) target.classList.remove('is-dragging');
      if (typeof target.releasePointerCapture === 'function' && pointerId != null) {
        try { target.releasePointerCapture(pointerId); } catch (error) {}
      }
      pointerId = null;
    }

    target.addEventListener('pointerup', release);
    target.addEventListener('pointercancel', release);
    target.addEventListener('dragstart', function (event) { event.preventDefault(); });
  }

  function activateFilterButton(grid, target, button, event) {
    if (!grid || !grid._prewornNewInState) return;
    if (target && Date.now() < (target._prewornSuppressClickUntil || 0)) {
      if (event) event.preventDefault();
      return;
    }

    var category = button.getAttribute('data-pwhome-new-in-category') || '';
    if (category === grid._prewornNewInState.category) return;
    requestLatestProducts(grid, grid._prewornNewInState.department, category, true);
  }

  function bindFilterButtons(grid, target) {
    var buttons = target.querySelectorAll('[data-pwhome-new-in-category]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (event) {
        event.stopPropagation();
        activateFilterButton(grid, target, this, event);
      });
    }
  }

  function renderFilters(grid, summary) {
    var target = filterTarget(grid);
    if (!target || !summary || !Array.isArray(summary.categories)) return;

    var state = grid._prewornNewInState;
    var department = state ? state.department : '';
    if (!department) {
      target.hidden = true;
      target.innerHTML = '';
      return;
    }

    var prefix = department.toLowerCase() + ' ';

    var categories = summary.categories.filter(function (category) {
      var value = category && String(category.value || category.label || '').trim();
      var normalized = value.toLowerCase();
      var inDepartment = department === 'Kids'
        ? /^(?:girls|boys)\s/.test(normalized)
        : normalized.indexOf(prefix) === 0;
      return value && inDepartment && Number(category.count) > 0;
    });
    if (!categories.length) {
      target.hidden = true;
      target.innerHTML = '';
      return;
    }

    var selected = state ? state.category : '';
    var total = departmentCount(summary, department);
    var markup = '<span class="pwhome__new-in-filters-label">' + escapeHtml(department.toUpperCase()) + '</span>' +
      '<button type="button" class="pwhome__new-in-filter' +
        (selected === '' ? ' is-active' : '') + '" data-pwhome-new-in-category="" aria-pressed="' +
        (selected === '' ? 'true' : 'false') + '" aria-label="All ' + escapeAttr(department) + ' new in, ' +
        total.toLocaleString('en-GB') + ' products">' +
        '<span class="pwhome__new-in-filter-name">ALL ' + escapeHtml(department.toUpperCase()) + '</span>' +
        '<span class="pwhome__new-in-filter-count">' + total.toLocaleString('en-GB') + '</span></button>';

    for (var i = 0; i < categories.length; i++) {
      var value = String(categories[i].value || categories[i].label).trim();
      var label = String(categories[i].label || value).trim();
      var count = Math.max(0, Number(categories[i].count) || 0);
      if (department !== 'Kids' && label.toLowerCase().indexOf(prefix) === 0) {
        label = label.slice(department.length + 1);
      }
      var displayLabel = pluralCategory(label, count).toUpperCase();
      var active = value === selected;
      markup += '<button type="button" class="pwhome__new-in-filter' +
        (active ? ' is-active' : '') + '" data-pwhome-new-in-category="' + escapeAttr(value) +
        '" aria-pressed="' + (active ? 'true' : 'false') + '" aria-label="' +
        escapeAttr(department + ' ' + displayLabel + ', ' + count.toLocaleString('en-GB') +
          (count === 1 ? ' product' : ' products')) + '">' +
        '<span class="pwhome__new-in-filter-name">' + escapeHtml(displayLabel) + '</span>' +
        '<span class="pwhome__new-in-filter-count">' + count.toLocaleString('en-GB') + '</span></button>';
    }

    target.innerHTML = markup;
    target.setAttribute('data-window-days', String(summary.windowDays || 7));
    target.hidden = false;
    bindFilterRail(target);
    bindFilterButtons(grid, target);
  }

  function catalogueUrl(grid, department, category, page) {
    var endpoint = grid.getAttribute('data-catalog-api');
    var windowDays = Math.max(1, Math.min(28, Number(grid.getAttribute('data-new-in-window-days')) || 7));
    var pageSize = Math.max(1, Math.min(100, Number(grid.getAttribute('data-products-to-show')) || 24));
    var url = new URL(endpoint, window.location.href);
    // Cloudways/Varnish previously cached an originless response without its
    // CORS header. Keep homepage catalogue requests on a fresh cache
    // generation so first-time and signed-out visitors receive a readable
    // response instead of depending on browser-local homepage data.
    url.searchParams.set('api_v', '20261027-home-cors-v2');
    url.searchParams.set('action', 'search');
    url.searchParams.set('page', String(Math.max(1, Number(page) || 1)));
    url.searchParams.set('limit', String(pageSize));
    url.searchParams.set('sort', 'newest');
    url.searchParams.set('include_facets', '0');
    // The cached New In summary already contains the visual total for this
    // department/category, so do not scan the matching products to count them.
    url.searchParams.set('count_mode', 'summary');
    url.searchParams.set('new_in', '1');
    url.searchParams.set('window_days', String(windowDays));
    if (department) url.searchParams.set('new_in_department', department);
    if (category) url.searchParams.set('new_in_category', category);
    return url.toString();
  }

  function requestLatestProducts(grid, department, category, resetScroll) {
    var state = grid._prewornNewInState;
    if (!state || typeof window.fetch !== 'function') return;

    var previousDepartment = state.department;
    var previousCategory = state.category;
    var previousPage = state.page;
    var previousLoaded = state.loaded;
    var previousTotal = state.total;
    var previousHasNextPage = state.hasNextPage;
    state.department = String(department || '');
    state.category = String(category || '');
    state.loading = true;
    state.hasNextPage = false;
    state.requestId += 1;
    var requestId = state.requestId;
    if (state.controller) state.controller.abort();
    state.controller = typeof window.AbortController === 'function'
      ? new window.AbortController()
      : null;
    var controller = state.controller;

    var target = filterTarget(grid);
    var departments = departmentTarget(grid);
    var departmentControls = sectionFor(grid);
    if (target && previousDepartment !== state.department) target.hidden = true;
    renderDepartmentSelection(departmentControls, state.department);
    renderFilterSelection(target, state.category);
    grid.setAttribute('aria-busy', 'true');
    if (target) target.setAttribute('aria-busy', 'true');
    if (departments) departments.setAttribute('aria-busy', 'true');
    updateLoadMore(grid);

    var timer = controller ? window.setTimeout(function () {
      controller.abort();
    }, REQUEST_TIMEOUT) : null;

    window.fetch(catalogueUrl(grid, state.department, state.category, 1), {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Catalogue HTTP ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        if (requestId !== state.requestId) return;
        if (!payload || payload.source !== 'preworn_catalog_index' || !Array.isArray(payload.items)) {
          throw new Error('Invalid catalogue response');
        }

        var products = payload.items
          .filter(function (product) { return product && product.availableForSale !== false; })
          .slice(0, state.count);
        renderProducts(grid, products, 'preworn-catalogue');
        state.page = Math.max(1, Number(payload.page) || 1);
        state.loaded = products.length;
        state.total = Math.max(products.length, Number(payload.totalCount) || products.length);
        state.hasNextPage = payload.hasNextPage === true;
        state.summary = payload.newIn;
        renderDepartments(grid, payload.newIn);
        renderFilters(grid, payload.newIn);

        if (resetScroll && typeof grid.scrollTo === 'function') {
          grid.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          grid.scrollLeft = 0;
        }
      })
      .catch(function (error) {
        if (requestId !== state.requestId) return;
        state.department = previousDepartment;
        state.category = previousCategory;
        state.page = previousPage;
        state.loaded = previousLoaded;
        state.total = previousTotal;
        state.hasNextPage = previousHasNextPage;
        renderDepartmentSelection(departmentControls, previousDepartment);
        renderFilterSelection(target, previousCategory);
        if (state.summary) renderFilters(grid, state.summary);
        console.warn('[Preworn Home] Latest products unavailable; keeping the previous products.', error);
      })
      .then(function () {
        if (timer) window.clearTimeout(timer);
        if (requestId !== state.requestId) return;
        state.loading = false;
        state.controller = null;
        grid.setAttribute('aria-busy', 'false');
        if (target) target.setAttribute('aria-busy', 'false');
        if (departments) departments.setAttribute('aria-busy', 'false');
        updateLoadMore(grid);
      });
  }

  function requestNextPage(grid) {
    var state = grid._prewornNewInState;
    if (!state || state.loading || !state.hasNextPage || typeof window.fetch !== 'function') return;

    state.loading = true;
    state.requestId += 1;
    var requestId = state.requestId;
    var nextPage = state.page + 1;
    if (state.controller) state.controller.abort();
    state.controller = typeof window.AbortController === 'function'
      ? new window.AbortController()
      : null;
    var controller = state.controller;
    grid.setAttribute('aria-busy', 'true');
    updateLoadMore(grid);

    var timer = controller ? window.setTimeout(function () {
      controller.abort();
    }, REQUEST_TIMEOUT) : null;

    window.fetch(catalogueUrl(grid, state.department, state.category, nextPage), {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Catalogue HTTP ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        if (requestId !== state.requestId) return;
        if (!payload || payload.source !== 'preworn_catalog_index' || !Array.isArray(payload.items)) {
          throw new Error('Invalid catalogue response');
        }

        var products = payload.items
          .filter(function (product) { return product && product.availableForSale !== false; })
          .slice(0, state.count);
        renderProducts(grid, products, 'preworn-catalogue', true);
        state.page = Math.max(nextPage, Number(payload.page) || nextPage);
        state.loaded += products.length;
        state.total = Math.max(state.loaded, Number(payload.totalCount) || state.loaded);
        state.hasNextPage = payload.hasNextPage === true && products.length > 0;
      })
      .catch(function (error) {
        if (requestId !== state.requestId) return;
        console.warn('[Preworn Home] More new products could not be loaded.', error);
      })
      .then(function () {
        if (timer) window.clearTimeout(timer);
        if (requestId !== state.requestId) return;
        state.loading = false;
        state.controller = null;
        grid.setAttribute('aria-busy', 'false');
        updateLoadMore(grid);
      });
  }

  function bindLoadMore(grid) {
    var target = moreTarget(grid);
    var button = target ? target.querySelector('[data-pwhome-new-in-load-more]') : null;
    if (!button || button._prewornLoadMoreReady) return;
    button._prewornLoadMoreReady = true;
    button.addEventListener('click', function () { requestNextPage(grid); });
  }

  function initialiseGrid(grid) {
    if (!grid || grid.getAttribute('data-new-in-ready') === 'true') return;

    var renderer = cardRenderer();
    if (!renderer) {
      window.setTimeout(function () { initialiseGrid(grid); }, 25);
      return;
    }

    grid.setAttribute('data-new-in-ready', 'true');
    renderer.ensureStyles();
    var initialDepartment = String(grid.getAttribute('data-initial-department') || '').trim();
    if (!/^(?:Womens|Mens|Kids)$/.test(initialDepartment)) initialDepartment = '';
    grid._prewornNewInState = {
      department: initialDepartment,
      category: '',
      count: Math.max(1, Math.min(100, Number(grid.getAttribute('data-products-to-show')) || 24)),
      page: 1,
      loaded: 0,
      total: 0,
      hasNextPage: false,
      loading: false,
      summary: null,
      requestId: 0,
      controller: null
    };

    renderProducts(
      grid,
      fallbackProducts(grid).slice(0, grid._prewornNewInState.count),
      'shopify-fallback'
    );
    bindLoadMore(grid);
    requestLatestProducts(grid, initialDepartment, '', false);
  }

  function brandHref(section, name) {
    var searchUrl = String(section.getAttribute('data-brand-search-url') || '/search');
    var encodedName = encodeURIComponent(name);
    var href = searchUrl + (searchUrl.indexOf('?') === -1 ? '?' : '&') +
      'q=' + encodedName + '&brand=' + encodedName;
    var department = departmentSearchValue(section);
    return href + (department ? '&department=' + encodeURIComponent(department) : '');
  }

  function categoryHref(section, name) {
    var searchUrl = String(section.getAttribute('data-brand-search-url') || '/search');
    var encodedName = encodeURIComponent(name);
    var href = searchUrl + (searchUrl.indexOf('?') === -1 ? '?' : '&') +
      'type=' + encodedName;
    var department = departmentSearchValue(section);
    return href + (department ? '&department=' + encodeURIComponent(department) : '');
  }

  function rankingFilterParameter(category) {
    var parameter = String(category && category.filterParameter || 'type').toLowerCase();
    return ['type', 'style', 'vendor'].indexOf(parameter) !== -1 ? parameter : 'type';
  }

  function rankingDimensionLabel(category) {
    var label = String(category && category.dimensionLabel || '').trim();
    if (label) return label;
    return { type: 'Type', style: 'Style', vendor: 'Brand' }[
      rankingFilterParameter(category)
    ] || 'Type';
  }

  function rankingDimensionPlural(category) {
    var label = rankingDimensionLabel(category);
    return /y$/i.test(label) ? label.slice(0, -1) + 'ies' : label + 's';
  }

  function trendHref(section, category) {
    var name = String(category && category.name || '').trim();
    var parameter = rankingFilterParameter(category);
    if (parameter === 'vendor') {
      return brandHref(section, name) + '&sort=trending';
    }
    var searchUrl = String(section.getAttribute('data-brand-search-url') || '/search');
    var href = searchUrl + (searchUrl.indexOf('?') === -1 ? '?' : '&') +
      parameter + '=' + encodeURIComponent(name) + '&sort=trending';
    var department = departmentSearchValue(section);
    return href + (department ? '&department=' + encodeURIComponent(department) : '');
  }

  function trendDirectoryHref(section, view) {
    if (view && view.key === 'vendor') {
      return String(section.getAttribute('data-brand-directory-url') || '/pages/brands');
    }
    var searchUrl = String(section.getAttribute('data-brand-search-url') || '/search');
    var href = searchUrl + (searchUrl.indexOf('?') === -1 ? '?' : '&') + 'q=*&sort=trending';
    var department = departmentSearchValue(section);
    return href + (department ? '&department=' + encodeURIComponent(department) : '');
  }

  var HOMEPAGE_BRANDS = [
    { name: 'Nike', aliases: ['Nike'], tile: 'hero' },
    { name: 'Adidas', aliases: ['Adidas'], tile: 'hero' },
    { name: 'Zara', aliases: ['Zara'], tile: 'wide' },
    { name: "Levi's", aliases: ["Levi's"], tile: 'wide' },
    { name: 'The North Face', aliases: ['The North Face'], tile: 'wide' },
    { name: 'Ralph Lauren', aliases: ['Ralph Lauren'], tile: 'wide' },
    { name: 'Tommy Hilfiger', aliases: ['Tommy Hilfiger'], tile: 'wide' },
    { name: 'H&M', aliases: ['H&M'] },
    { name: 'M&S', search: 'Marks & Spencer', aliases: ['Marks & Spencer', 'Marks and Spencer', 'm&s'] },
    { name: 'Next', aliases: ['NEXT'] },
    { name: 'New Look', aliases: ['New Look'] },
    { name: 'Topshop', aliases: ['Topshop'] },
    { name: 'ASOS', aliases: ['ASOS'] },
    { name: 'River Island', aliases: ['River Island'] },
    { name: 'Mango', aliases: ['Mango'] },
    { name: 'Puma', aliases: ['PUMA'] },
    { name: 'Reebok', aliases: ['Reebok'] },
    { name: 'Under Armour', aliases: ['Under Armour'] }
  ];

  function normaliseBrandName(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[\u2018\u2019']/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function departmentBrandLeaders(indexed) {
    var candidates = [];
    var used = {};

    // Consolidate known vendor spellings before ranking them. This keeps aliases
    // such as Marks & Spencer / Marks and Spencer from occupying two positions,
    // without giving the homepage's fixed shortlist any ranking preference.
    for (var c = 0; c < HOMEPAGE_BRANDS.length; c++) {
      var merchandising = HOMEPAGE_BRANDS[c];
      var candidate = {
        name: merchandising.name,
        search: merchandising.search || merchandising.name,
        count: 0,
        soldToday: 0,
        sold7Days: 0,
        sold30Days: 0
      };
      for (var a = 0; a < merchandising.aliases.length; a++) {
        var aliasKey = normaliseBrandName(merchandising.aliases[a]);
        if (used[aliasKey]) continue;
        var match = indexed[aliasKey];
        used[aliasKey] = true;
        if (!match) continue;
        candidate.count += match.count;
        candidate.soldToday += match.soldToday;
        candidate.sold7Days += match.sold7Days;
        candidate.sold30Days += match.sold30Days;
      }
      if (candidate.count) candidates.push(candidate);
    }

    Object.keys(indexed).forEach(function (key) {
      if (used[key] || /^(?:vintage|classics|unbranded|unknown|other)$/.test(key)) return;
      var brand = indexed[key];
      candidates.push({
        name: brand.name,
        search: brand.name,
        count: brand.count,
        soldToday: brand.soldToday,
        sold7Days: brand.sold7Days,
        sold30Days: brand.sold30Days
      });
    });

    candidates = candidates.filter(function (brand) {
      return brand.sold7Days > 0;
    }).sort(function (left, right) {
      return (right.sold7Days - left.sold7Days) ||
        (right.soldToday - left.soldToday) ||
        (right.sold30Days - left.sold30Days) ||
        (right.count - left.count) ||
        left.name.localeCompare(right.name);
    });

    // On a normally active department, a single sale is too weak a signal for
    // "best brands". Retain a small-data fallback so quieter departments do not
    // become empty while still remaining driven only by real department sales.
    var meaningful = candidates.filter(function (brand) {
      return brand.sold7Days >= 2;
    });
    var leaders = meaningful.length >= 6 ? meaningful : candidates;
    return leaders.slice(0, 18).map(function (brand, index) {
      brand.tile = index < 2 ? 'hero' : (index < 7 ? 'wide' : '');
      return brand;
    });
  }

  function curateHomepageBrands(brands, useDepartmentRanking) {
    var indexed = {};
    for (var i = 0; i < brands.length; i++) {
      var brand = brands[i];
      var key = normaliseBrandName(brand && brand.name);
      var count = Math.max(0, Number(brand && brand.count) || 0);
      if (!key || !count) continue;
      if (!indexed[key]) indexed[key] = {
        name: String(brand.name || '').trim(),
        count: 0,
        soldToday: 0,
        sold7Days: 0,
        sold30Days: 0
      };
      indexed[key].count += count;
      indexed[key].soldToday += Math.max(0, Number(brand && brand.soldToday) || 0);
      indexed[key].sold7Days += Math.max(0, Number(brand && brand.sold7Days) || 0);
      indexed[key].sold30Days += Math.max(0, Number(brand && brand.sold30Days) || 0);
    }

    var curated = useDepartmentRanking ? departmentBrandLeaders(indexed) : [];
    for (var c = 0; !useDepartmentRanking && c < HOMEPAGE_BRANDS.length; c++) {
      var merchandising = HOMEPAGE_BRANDS[c];
      var total = 0;
      var soldToday = 0;
      var sold7Days = 0;
      var sold30Days = 0;
      var used = {};
      for (var a = 0; a < merchandising.aliases.length; a++) {
        var aliasKey = normaliseBrandName(merchandising.aliases[a]);
        if (!used[aliasKey] && indexed[aliasKey]) {
          total += indexed[aliasKey].count;
          soldToday += indexed[aliasKey].soldToday;
          sold7Days += indexed[aliasKey].sold7Days;
          sold30Days += indexed[aliasKey].sold30Days;
        }
        used[aliasKey] = true;
      }
      if (!total) continue;
      curated.push({
        name: merchandising.name,
        search: merchandising.search || merchandising.name,
        count: total,
        soldToday: soldToday,
        sold7Days: sold7Days,
        sold30Days: sold30Days,
        tile: merchandising.tile || ''
      });
    }

    var soldRanking = curated.filter(function (brand) {
      return brand.sold7Days > 0;
    }).sort(function (left, right) {
      return (right.sold7Days - left.sold7Days) ||
        (right.soldToday - left.soldToday) ||
        (right.sold30Days - left.sold30Days) ||
        (right.count - left.count);
    });
    for (var rank = 0; rank < Math.min(3, soldRanking.length); rank++) {
      soldRanking[rank].topSeller = true;
      soldRanking[rank].featured = rank === 0;
      soldRanking[rank].badge = rank === 0 ? 'TOP BRAND \u00b7 7 DAYS' : 'POPULAR THIS WEEK';
    }
    return curated;
  }

  function renderCatalogueStats(section, stats) {
    if (!section || !stats) return;
    var values = [
      ['[data-pwhome-catalogue-available]', stats.availableCount],
      ['[data-pwhome-catalogue-new]', stats.newInCount],
      ['[data-pwhome-catalogue-sold]', stats.sold30Days]
    ];
    for (var i = 0; i < values.length; i++) {
      var target = section.querySelector(values[i][0]);
      if (target) target.textContent = compactCount(values[i][1]);
    }
  }

  function renderPopularCategories(section, categories, view) {
    var grid = section.querySelector('[data-pwhome-category-grid]');
    if (!grid) return;
    if (!Array.isArray(categories)) {
      grid.setAttribute('aria-busy', 'false');
      return;
    }
    var markup = '';
    var validCategories = [];
    for (var i = 0; i < categories.length; i++) {
      var category = categories[i] || {};
      var name = String(category.name || '').trim();
      var sold30Days = Math.max(0, Number(category.sold30Days) || 0);
      var availableCount = Math.max(0, Number(category.availableCount) || 0);
      var imageUrl = String(category.imageUrl || '').trim();
      if (!/^https:\/\//i.test(imageUrl)) imageUrl = '';
      if (!name || !sold30Days || !availableCount) continue;
      validCategories.push({
        name: name,
        filterParameter: rankingFilterParameter(category),
        dimensionLabel: rankingDimensionLabel(category),
        sold30Days: sold30Days,
        availableCount: availableCount,
        imageUrl: imageUrl
      });
    }

    validCategories.sort(function (left, right) {
      return right.sold30Days - left.sold30Days ||
        right.availableCount - left.availableCount ||
        left.name.localeCompare(right.name);
    });

    // Match the tag-page board exactly: three featured cards, six compact
    // cards and (when all twelve are available) three wide cards. Ten or
    // eleven results stop at nine so an incomplete final row is never shown.
    var renderLimit = validCategories.length > 9 && validCategories.length < 12
      ? 9
      : Math.min(validCategories.length, 12);
    var scopeLabel = departmentFocus(section) || 'Preworn';
    var viewKey = view && view.key ||
      (validCategories[0] ? validCategories[0].filterParameter : 'type');
    var viewLabel = view && view.singularLabel ||
      (validCategories[0] ? validCategories[0].dimensionLabel : 'Type');
    var editorialNotes = [
      'ICONIC STYLE. A BRIGHTER TOMORROW.',
      'TIMELESS COMFORT. REAL IMPACT.',
      'MOVE MORE. WASTE LESS.'
    ];
    for (var categoryIndex = 0; categoryIndex < renderLimit; categoryIndex++) {
      var validCategory = validCategories[categoryIndex];
      var rank = categoryIndex + 1;
      var displayName = (viewKey === 'type'
        ? pluralCategory(validCategory.name, validCategory.availableCount)
        : validCategory.name).toUpperCase();
      var imageClass = validCategory.imageUrl ? '' : ' pwbrandpage__selling-card--no-image';
      var mediaMarkup = validCategory.imageUrl
        ? '<img src="' + escapeAttr(validCategory.imageUrl) + '" alt="" loading="lazy" decoding="async">'
        : '<span class="pwbrandpage__selling-placeholder" aria-hidden="true">' +
            '<small>PREWORN</small><strong>' + escapeHtml(displayName) + '</strong>' +
            '<em>CATEGORY</em></span>';
      var layoutClass = rank <= 3
        ? 'pwbrandpage__selling-card--featured'
        : (rank >= 10 ? 'pwbrandpage__selling-card--wide' : 'pwbrandpage__selling-card--compact');
      var label = 'Shop ' + displayName + ', ' + validCategory.sold30Days.toLocaleString('en-GB') +
        ' sold in the last 30 days, ' + validCategory.availableCount.toLocaleString('en-GB') + ' available now';
      markup += '<a class="pwbrandpage__selling-card ' + layoutClass + imageClass + '" href="' +
        escapeAttr(trendHref(section, validCategory)) + '" aria-label="' + escapeAttr(label) + '">' +
        '<span class="pwbrandpage__selling-media">' +
          mediaMarkup +
        '</span>' +
        '<span class="pwbrandpage__selling-rank"><b>#' + String(rank).padStart(2, '0') +
          '</b><small>30 DAY</small></span>' +
        (rank === 1 ? '<span class="pwbrandpage__selling-popular">MOST POPULAR</span>' : '') +
        '<span class="pwbrandpage__selling-copy">' +
          '<small>' + escapeHtml(scopeLabel.toUpperCase()) + '</small>' +
          '<strong>' + escapeHtml(displayName) + '</strong>' +
          '<span class="pwbrandpage__selling-sales"><b>' + validCategory.sold30Days.toLocaleString('en-GB') +
          '</b> SOLD \u00b7 30 DAYS</span>' +
          '<span class="pwbrandpage__selling-available">' + validCategory.availableCount.toLocaleString('en-GB') +
          ' AVAILABLE NOW</span>' +
          '<span class="pwbrandpage__selling-action">SHOP ' + escapeHtml(viewLabel.toUpperCase()) +
          ' <b aria-hidden="true">\u2197</b></span>' +
        '</span>' +
        (rank <= 3
          ? '<span class="pwbrandpage__selling-note"><i aria-hidden="true"></i><span>' +
            escapeHtml(editorialNotes[rank - 1]) + '</span></span>'
          : '') +
      '</a>';
    }
    if (renderLimit) grid.innerHTML = markup;
    grid.setAttribute('aria-busy', 'false');
  }

  function renderTrendSummary(section, categories, view) {
    var summary = section.querySelector('[data-pwhome-trend-summary]');
    var risingList = section.querySelector('[data-pwhome-rising-list]');
    var todayList = section.querySelector('[data-pwhome-most-today]');
    var heading = section.querySelector('[data-pwhome-trend-summary-heading]');
    var graphLabels = section.querySelector('[data-pwhome-trend-graph-labels]');
    var overline = section.querySelector('[data-pwhome-trend-overline]');
    var intro = section.querySelector('[data-pwhome-trend-intro]');
    var wordmark = section.querySelector('[data-pwhome-trend-wordmark]');
    var leaderboardHeading = section.querySelector('[data-pwhome-trend-leaderboard-heading]');
    var leaderboardContext = section.querySelector('[data-pwhome-trend-leaderboard-context]');
    var cta = section.querySelector('[data-pwhome-trend-cta]');
    if (!summary || !risingList || !todayList || !Array.isArray(categories)) return;

    var normalized = categories.map(function (category) {
      category = category || {};
      var sold7Days = Math.max(0, Number(category.sold7Days) || 0);
      var soldPrevious7Days = Math.max(0, Number(category.soldPrevious7Days) || 0);
      return {
        name: String(category.name || '').trim(),
        filterParameter: rankingFilterParameter(category),
        dimensionLabel: rankingDimensionLabel(category),
        availableCount: Math.max(0, Number(category.availableCount) || 0),
        soldToday: Math.max(0, Number(category.soldToday) || 0),
        sold30Days: Math.max(0, Number(category.sold30Days) || 0),
        sold7Days: sold7Days,
        soldPrevious7Days: soldPrevious7Days,
        trendScore: soldPrevious7Days ? sold7Days / soldPrevious7Days : 0,
        trendChangePercent: soldPrevious7Days
          ? Math.round(((sold7Days - soldPrevious7Days) / soldPrevious7Days) * 100)
          : 0
      };
    }).filter(function (category) {
      return category.name && category.availableCount > 0;
    });

    var example = normalized[0] || {
      filterParameter: view && view.key || 'type',
      dimensionLabel: view && view.singularLabel || 'Type'
    };
    var pluralLabel = String(view && view.label || rankingDimensionPlural(example));
    var singularLabel = String(view && view.singularLabel || rankingDimensionLabel(example));

    var rising = normalized.filter(function (category) {
      return category.sold7Days >= 12 && category.soldPrevious7Days >= 5 &&
        category.trendScore > 1;
    }).sort(function (left, right) {
      return right.trendScore - left.trendScore || right.sold7Days - left.sold7Days;
    }).slice(0, 3);

    var isMomentumFallback = false;
    if (!rising.length) {
      isMomentumFallback = true;
      rising = normalized.slice().sort(function (left, right) {
        return right.sold7Days - left.sold7Days;
      }).slice(0, 3);
    }

    var mostToday = normalized.filter(function (category) {
      return category.soldToday > 0;
    }).sort(function (left, right) {
      return right.soldToday - left.soldToday || right.sold7Days - left.sold7Days;
    }).slice(0, 4);
    var most30Days = normalized.filter(function (category) {
      return category.sold30Days > 0;
    }).sort(function (left, right) {
      return right.sold30Days - left.sold30Days || right.sold7Days - left.sold7Days;
    }).slice(0, 4);
    var todayVolume = mostToday.reduce(function (total, category) {
      return total + category.soldToday;
    }, 0);
    var showToday = mostToday.length >= 3 && todayVolume >= 12;
    var leaderboard = showToday ? mostToday : most30Days;

    if (!rising.length && !leaderboard.length) return;
    var stateLabel = 'TRENDING.';
    if (heading) {
      heading.innerHTML = '<span>' + escapeHtml(pluralLabel.toUpperCase()) + '</span> ' +
        escapeHtml(stateLabel);
    }
    if (overline) {
      overline.innerHTML = '<i aria-hidden="true"></i>LIVE ' +
        escapeHtml(singularLabel.toUpperCase()) + ' MOMENTUM \u00b7 VS PREVIOUS 7 DAYS';
    }
    if (wordmark) wordmark.textContent = pluralLabel.toUpperCase();
    if (intro) {
      intro.textContent = 'The ' + pluralLabel.toLowerCase() +
        ' gaining momentum right now, based on week-on-week sales movement.';
    }
    risingList.setAttribute('aria-label', pluralLabel + ' rising fastest');
    if (leaderboardHeading) {
      leaderboardHeading.textContent = showToday ? 'MOST SOLD TODAY' : 'MOST SOLD \u00b7 30 DAYS';
    }
    if (leaderboardContext) {
      leaderboardContext.textContent = showToday
        ? 'UPDATED LIVE' : singularLabel.toUpperCase() + ' DEMAND';
    }
    if (cta) {
      cta.href = trendDirectoryHref(section, view);
      var ctaLabel = cta.querySelector('b');
      if (ctaLabel) ctaLabel.textContent = view && view.key === 'vendor'
        ? 'EXPLORE TRENDING BRANDS' : 'SHOP TRENDING ' + pluralLabel.toUpperCase();
    }

    risingList.innerHTML = rising.map(function (category, index) {
      var change = isMomentumFallback
        ? category.sold7Days.toLocaleString('en-GB') + ' SOLD THIS WEEK'
        : '+' + category.trendChangePercent.toLocaleString('en-GB') + '% VS LAST WEEK';
      var salesComparison = category.soldPrevious7Days
        ? category.sold7Days.toLocaleString('en-GB') + ' SOLD THIS WEEK \u00b7 ' +
          category.soldPrevious7Days.toLocaleString('en-GB') + ' LAST WEEK'
        : category.sold7Days.toLocaleString('en-GB') + ' SOLD THIS WEEK';
      var label = 'Shop ' + category.name + ', ' + change.toLowerCase();
      return '<a class="pwhome__trend-card" href="' +
        escapeAttr(trendHref(section, category)) + '" aria-label="' + escapeAttr(label) + '">' +
        '<small>' + (index + 1).toString().padStart(2, '0') + '</small>' +
        '<span class="pwhome__trend-card-copy"><strong>' + escapeHtml(category.name) + '</strong>' +
          '<span>' + escapeHtml(salesComparison) + '</span></span>' +
        '<em>' + escapeHtml(change) + '</em>' +
        '<i aria-hidden="true">\u2197</i>' +
      '</a>';
    }).join('');

    if (graphLabels) {
      graphLabels.innerHTML = rising.map(function (category, index) {
        var value = isMomentumFallback
          ? category.sold7Days.toLocaleString('en-GB')
          : '+' + category.trendChangePercent.toLocaleString('en-GB') + '%';
        return '<span class="pwhome__trend-graph-label pwhome__trend-graph-label--' + (index + 1) + '">' +
          '<strong><b>#' + (index + 1) + '</b> ' + escapeHtml(value) + '</strong>' +
          '<small>' + escapeHtml(category.name) + '</small>' +
        '</span>';
      }).join('');
    }

    todayList.innerHTML = leaderboard.map(function (category, index) {
      var count = showToday ? category.soldToday : category.sold30Days;
      var period = showToday ? 'sold today' : 'sold in the last 30 days';
      var label = 'Shop ' + category.name + ', ' + count.toLocaleString('en-GB') + ' ' + period;
      return '<a href="' + escapeAttr(trendHref(section, category)) +
        '" aria-label="' + escapeAttr(label) + '">' +
        '<small>#' + (index + 1) + '</small><strong>' + escapeHtml(category.name) + '</strong>' +
        '<b>' + count.toLocaleString('en-GB') + '</b>' +
      '</a>';
    }).join('');

    summary.hidden = false;
  }

  function homepageTrendViews(payload) {
    var rawViews = payload && Array.isArray(payload.trendViews)
      ? payload.trendViews : [];
    if (!rawViews.length && payload && Array.isArray(payload.popularCategories)) {
      rawViews = [{
        dimension: { parameter: 'type', label: 'Type' },
        categories: payload.popularCategories
      }];
    }
    return rawViews.map(function (rawView) {
      rawView = rawView || {};
      var categories = Array.isArray(rawView.categories) ? rawView.categories : [];
      var dimension = rawView.dimension || {};
      var example = categories[0] || {
        filterParameter: dimension.parameter,
        dimensionLabel: dimension.label
      };
      return {
        key: rankingFilterParameter(example),
        singularLabel: rankingDimensionLabel(example),
        label: rankingDimensionPlural(example),
        categories: categories
      };
    }).filter(function (view, index, views) {
      return view.categories.length > 0 && views.findIndex(function (candidate) {
        return candidate.key === view.key;
      }) === index;
    });
  }

  function renderTrendTabs(section) {
    var tabs = section.querySelector('[data-pwhome-trend-tabs]');
    var views = Array.isArray(section._prewornTrendViews)
      ? section._prewornTrendViews : [];
    if (!tabs) return;
    if (views.length < 2) {
      tabs.hidden = true;
      tabs.innerHTML = '';
      return;
    }
    var sectionId = String(section.getAttribute('data-section-id') || 'homepage');
    tabs.innerHTML = '<span>EXPLORE LIVE DEMAND BY</span>' + views.map(function (trendView, index) {
      var active = trendView.key === section._prewornTrendView;
      return '<button type="button" role="tab" data-pwhome-trend-view="' +
        escapeAttr(trendView.key) + '" aria-selected="' + (active ? 'true' : 'false') +
        '" aria-controls="PrewornTrendSummary-' + escapeAttr(sectionId) + '" tabindex="' +
        (active ? '0' : '-1') + '" class="' + (active ? 'is-active' : '') + '">' +
        '<small>0' + (index + 1) + '</small><strong>' +
        escapeHtml(trendView.label.toUpperCase()) + '</strong><em>LIVE RANKING</em></button>';
    }).join('');
    tabs.hidden = false;
  }

  function selectTrendView(section, key) {
    var views = Array.isArray(section._prewornTrendViews)
      ? section._prewornTrendViews : [];
    var selected = views.filter(function (trendView) {
      return trendView.key === key;
    })[0] || views[0];
    if (!selected) return false;
    section._prewornTrendView = selected.key;
    renderTrendTabs(section);
    renderTrendSummary(section, selected.categories, selected);
    renderPopularCategories(section, selected.categories, selected);
    return true;
  }

  function applyTrendViews(section, payload) {
    var views = homepageTrendViews(payload);
    section._prewornTrendViews = views;
    var current = views.some(function (trendView) {
      return trendView.key === section._prewornTrendView;
    }) ? section._prewornTrendView : (views[0] ? views[0].key : '');
    if (!current) {
      renderTrendTabs(section);
      return false;
    }
    return selectTrendView(section, current);
  }

  function renderBrands(section) {
    var state = section._prewornBrandState;
    var grid = section.querySelector('[data-pwhome-brand-grid]');
    if (!state || !grid) return;
    var markup = '';
    for (var i = 0; i < state.brands.length; i++) {
      var brand = state.brands[i];
      var name = String(brand.name || '').trim();
      var count = Math.max(0, Number(brand.count) || 0);
      var soldToday = Math.max(0, Number(brand.soldToday) || 0);
      var sold7Days = Math.max(0, Number(brand.sold7Days) || 0);
      if (!name) continue;
      var label = 'Shop ' + name + ', ' + count.toLocaleString('en-GB') +
        ' available' +
        (sold7Days ? ', ' + sold7Days.toLocaleString('en-GB') + ' sold in the last 7 days' : '') +
        (soldToday ? ', ' + soldToday.toLocaleString('en-GB') + ' sold today' : '');
      var tileClass = brand.tile ? ' pwhome__brand--' + brand.tile : '';
      if (brand.topSeller) tileClass += ' pwhome__brand--top-seller';
      var isFeatured = brand.featured === true;
      if (isFeatured) tileClass += ' pwhome__brand--featured';
      var badge = brand.badge;
      markup += '<a class="pwhome__brand' + tileClass + '" href="' +
        escapeAttr(brandHref(section, brand.search || name)) + '" aria-label="' + escapeAttr(label) + '">' +
        (badge ? '<em class="pwhome__brand-badge">' + escapeHtml(badge) + '</em>' : '') +
        '<span class="pwhome__brand-action">SHOP ' + escapeHtml(name) + ' <b aria-hidden="true">\u2192</b></span>' +
        '<span>' + escapeHtml(name) + '</span>' +
        '<div class="pwhome__brand-metrics"><small class="pwhome__brand-available">' + count.toLocaleString('en-GB') + ' AVAILABLE NOW</small>' +
        (sold7Days ? '<small class="pwhome__brand-sold"><b>' + sold7Days.toLocaleString('en-GB') + '</b> SOLD \u00b7 LAST 7 DAYS</small>' : '') +
        '</div></a>';
    }
    var directoryUrl = String(section.getAttribute('data-brand-directory-url') || '/pages/brands');
    markup += '<a class="pwhome__brand pwhome__brand--wide pwhome__brand--explore" href="' +
      escapeAttr(directoryUrl) + '" aria-label="Explore all brands">' +
      '<span>10,000+ BRANDS</span><small>FIND YOUR FAVOURITES</small></a>';
    grid.innerHTML = markup;
    grid.setAttribute('aria-busy', 'false');
  }

  var HOMEPAGE_SIGNALS_MAX_STALE_MS = 30 * 60 * 1000;

  function homepageSignalsCacheKey(focus) {
    return 'preworn:homepage-signals:v9:' + (focus || 'all').toLowerCase();
  }

  function readHomepageSignalsCache(focus) {
    try {
      if (!window.localStorage) return null;
      var cached = JSON.parse(window.localStorage.getItem(
        homepageSignalsCacheKey(focus)
      ) || 'null');
      if (!cached || !cached.savedAt || !cached.payload ||
          Date.now() - Number(cached.savedAt) > HOMEPAGE_SIGNALS_MAX_STALE_MS) {
        return null;
      }
      return cached.payload;
    } catch (error) {
      return null;
    }
  }

  function writeHomepageSignalsCache(focus, payload) {
    try {
      if (!window.localStorage) return;
      window.localStorage.setItem(homepageSignalsCacheKey(focus), JSON.stringify({
        savedAt: Date.now(),
        payload: payload
      }));
    } catch (error) {}
  }

  function renderColourCounts(section, colours) {
    if (!section || typeof section.querySelectorAll !== 'function' ||
        !Array.isArray(colours)) return;
    var counts = {};
    for (var i = 0; i < colours.length; i++) {
      var colour = colours[i] || {};
      var name = String(colour.name || '').trim().toLowerCase();
      if (name) counts[name] = Math.max(0, Number(colour.count) || 0);
    }
    var cards = section.querySelectorAll('[data-pwhome-colour]');
    for (var c = 0; c < cards.length; c++) {
      var cardName = String(cards[c].getAttribute('data-pwhome-colour') || '')
        .trim().toLowerCase();
      if (!Object.prototype.hasOwnProperty.call(counts, cardName)) continue;
      var target = cards[c].querySelector('[data-pwhome-colour-count]');
      if (!target) continue;
      var count = counts[cardName];
      target.textContent = compactCount(count) + (count === 1 ? ' piece' : ' pieces');
    }
  }

  function applyHomepageSignals(section, payload, focus) {
    if (!payload || payload.source !== 'preworn_catalog_index' ||
        !Array.isArray(payload.brands)) return false;
    var payloadDepartment = String(payload.department || '').trim();
    if (payloadDepartment !== String(focus || '')) return false;
    var brands = payload.brands.filter(function (brand) {
      return brand && String(brand.name || '').trim() && Number(brand.count) > 0;
    });
    var curatedBrands = curateHomepageBrands(brands, !!focus);
    section._prewornBrandState.brands = curatedBrands;
    var brandCount = section.querySelector('[data-pwhome-brand-count]');
    if (brandCount) brandCount.textContent = compactCount(payload.totalBrands);
    renderColourCounts(section, payload.colours);
    renderCatalogueStats(section, payload.catalogueStats);
    applyTrendViews(section, payload);
    if (curatedBrands.length) renderBrands(section);
    else {
      var grid = section.querySelector('[data-pwhome-brand-grid]');
      if (grid) grid.setAttribute('aria-busy', 'false');
    }
    return true;
  }

  function bindTrendTabs(section) {
    var tabs = section.querySelector('[data-pwhome-trend-tabs]');
    if (!tabs || tabs._prewornTrendTabsReady ||
        typeof tabs.addEventListener !== 'function') return;
    tabs._prewornTrendTabsReady = true;
    tabs.addEventListener('click', function (event) {
      var target = event.target;
      while (target && target !== tabs &&
          (!target.getAttribute || !target.getAttribute('data-pwhome-trend-view'))) {
        target = target.parentNode;
      }
      if (!target || target === tabs) return;
      selectTrendView(section, target.getAttribute('data-pwhome-trend-view'));
    });
    tabs.addEventListener('keydown', function (event) {
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
      var buttons = Array.prototype.slice.call(
        tabs.querySelectorAll('[data-pwhome-trend-view]')
      );
      var index = buttons.indexOf(event.target);
      if (index < 0 || !buttons.length) return;
      event.preventDefault();
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = buttons.length - 1;
      else if (event.key === 'ArrowLeft') index = (index - 1 + buttons.length) % buttons.length;
      else index = (index + 1) % buttons.length;
      var key = buttons[index].getAttribute('data-pwhome-trend-view');
      selectTrendView(section, key);
      var selected = tabs.querySelector('[data-pwhome-trend-view="' + key + '"]');
      if (selected && selected.focus) selected.focus();
    });
  }

  function initialiseBrandSection(section) {
    if (!section || section.getAttribute('data-brands-ready') === 'true') return;
    section.setAttribute('data-brands-ready', 'true');

    var grid = section.querySelector('[data-pwhome-brand-grid]');
    var categoryGrid = section.querySelector('[data-pwhome-category-grid]');
    section._prewornBrandState = { brands: [] };
    section._prewornTrendViews = [];
    bindTrendTabs(section);

    var endpoint = section.getAttribute('data-catalog-api');
    if (!endpoint || typeof window.fetch !== 'function') {
      if (grid) grid.setAttribute('aria-busy', 'false');
      return;
    }
    var url = new URL(endpoint, window.location.href);
    url.searchParams.set('api_v', '20261027-home-cors-v2');
    url.searchParams.set('action', 'brands');
    url.searchParams.set('limit', '500');
    url.searchParams.set('include_sold', '1');
    url.searchParams.set('metrics_version', '18');
    var focus = departmentFocus(section);
    if (focus) url.searchParams.set('department', focus);
    var cachedPayload = readHomepageSignalsCache(focus);
    var renderedCache = cachedPayload
      ? applyHomepageSignals(section, cachedPayload, focus) : false;
    window.fetch(url.toString(), {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Brand directory HTTP ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        if (!applyHomepageSignals(section, payload, focus)) {
          throw new Error('Invalid brand directory response');
        }
        writeHomepageSignalsCache(focus, payload);
      })
      .catch(function (error) {
        if (!renderedCache) {
          if (grid) grid.setAttribute('aria-busy', 'false');
          if (categoryGrid) categoryGrid.setAttribute('aria-busy', 'false');
        }
        console.warn('[Preworn Home] Brand directory unavailable; keeping theme fallbacks.', error);
      });
  }

  function safeActivityImage(value) {
    if (!value) return '';
    try {
      var parsed = new URL(value, window.location.origin);
      return parsed.protocol === 'https:' ? parsed.href : '';
    } catch (error) {
      return '';
    }
  }

  function safeActivityLink(value, title) {
    try {
      var parsed = new URL(value || '', window.location.origin);
      if (parsed.origin === window.location.origin) {
        return parsed.pathname + parsed.search + parsed.hash;
      }
    } catch (error) {
      // Fall through to a normal theme search.
    }
    return '/search?q=' + encodeURIComponent(title || 'Preloved fashion');
  }

  function activityAge(value) {
    var parsed = new Date(String(value || '').replace(' ', 'T'));
    if (!isFinite(parsed.getTime())) return 'JUST BOUGHT';
    var minutes = Math.max(0, Math.floor((Date.now() - parsed.getTime()) / 60000));
    if (minutes < 1) return 'JUST NOW';
    if (minutes < 60) return minutes + ' MIN AGO';
    var hours = Math.floor(minutes / 60);
    if (hours < 24) return hours + (hours === 1 ? ' HOUR AGO' : ' HOURS AGO');
    return 'RECENTLY BOUGHT';
  }

  function normaliseSoldCards(track, events) {
    var cards = track.querySelectorAll('.pw-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var event = events[i] || {};
      var removable = card.querySelectorAll(
        '.pw-card__actions,.pw-card__discount,.pw-card__sold-context,.pw-card__sold-action'
      );
      for (var r = 0; r < removable.length; r++) removable[r].remove();

      card.classList.add('pw-card--sold');
      var media = card.querySelector('.pw-card__media');
      if (media) {
        media.insertAdjacentHTML(
          'beforeend',
          '<div class="pw-card__discount pw-card__sold-badge" aria-label="Sold"><span>SOLD</span></div>'
        );
      }

      var body = card.querySelector('.pw-card__body');
      if (body) {
        body.insertAdjacentHTML(
          'beforeend',
          '<div class="pw-card__sold-context">JUST BOUGHT · ' +
            escapeHtml(activityAge(event.occurred_at)) + '</div>' +
          '<span class="pw-card__sold-action">FIND SIMILAR <b aria-hidden="true">\u2197</b></span>'
        );
      }
    }
  }

  function renderJustBought(section, payload) {
    var track = section.querySelector('[data-pwhome-just-bought-track]');
    var today = section.querySelector('[data-pwhome-sold-today]');
    var events = payload && Array.isArray(payload.events)
      ? payload.events
      : (payload && payload.event ? [payload.event] : []);
    var focus = departmentFocus(section);
    if (focus) {
      events = events.filter(function (event) {
        var value = String(event && event.attributes && event.attributes.department || '')
          .toLowerCase().trim();
        if (focus === 'Kids') return /^(?:girl|girls|boy|boys|kid|kids)$/.test(value);
        if (focus === 'Womens') return /^(?:woman|women|womens|female)$/.test(value);
        return /^(?:man|men|mens|male)$/.test(value);
      });
    }
    if (today) {
      today.textContent = Math.max(0, Number(payload && payload.stats && payload.stats.items_today) || 0)
        .toLocaleString('en-GB');
    }
    if (!track || !events.length) {
      if (track) track.setAttribute('aria-busy', 'false');
      return;
    }

    var renderer = cardRenderer();
    if (!renderer) {
      track.setAttribute('aria-busy', 'false');
      return;
    }

    var products = [];
    for (var i = 0; i < Math.min(50, events.length); i++) {
      var event = events[i] || {};
      var title = String(event.title || 'A one-off Preworn find');
      var link = safeActivityLink(event.similar_url, title);
      var image = safeActivityImage(event.image_url);
      var attributes = event.attributes && typeof event.attributes === 'object'
        ? event.attributes : {};
      products.push({
        id: 'sold:' + String(event.id || i),
        handle: '',
        title: title,
        vendor: String(event.vendor || ''),
        productType: String(attributes.type || ''),
        availableForSale: false,
        onlineStoreUrl: link,
        featuredImage: image ? {
          url: image,
          altText: title,
          width: null,
          height: null
        } : null,
        priceRange: { minVariantPrice: {
          amount: String(event.price || '0.00'),
          currencyCode: String(event.currency || 'GBP')
        } },
        compareAtPriceRange: { minVariantPrice: null },
        attributes: attributes,
        soldActivity: { age: activityAge(event.occurred_at) }
      });
    }
    track.innerHTML = renderer.renderList(products);
    normaliseSoldCards(track, events.slice(0, products.length));
    track.scrollLeft = 0;
    track.setAttribute('aria-busy', 'false');
    if (typeof track._prewornRestartCarousel === 'function') {
      track._prewornRestartCarousel();
    }
  }

  function bindJustBoughtCarousel(section) {
    var track = section.querySelector('[data-pwhome-just-bought-track]');
    if (!track || track._prewornCarouselReady || typeof track.addEventListener !== 'function') return;
    track._prewornCarouselReady = true;
    bindFilterRail(track);

    var timer = null;
    var direction = 1;
    var pause = { hover: false, focus: false, pointer: false, hidden: false };
    var reducedMotion = typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function isPaused() {
      return pause.hover || pause.focus || pause.pointer || pause.hidden;
    }

    function clearTimer() {
      window.clearTimeout(timer);
      timer = null;
    }

    function cardStep() {
      var card = track.querySelector('.pw-card');
      if (!card) return 0;
      var width = card.getBoundingClientRect
        ? card.getBoundingClientRect().width : card.offsetWidth;
      var gap = 0;
      if (typeof window.getComputedStyle === 'function') {
        var styles = window.getComputedStyle(track);
        gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      }
      return Math.max(0, width + gap);
    }

    function schedule(delay) {
      clearTimer();
      if (reducedMotion || isPaused()) return;
      timer = window.setTimeout(advance, delay || 3600);
    }

    function advance() {
      timer = null;
      if (isPaused() || document.visibilityState === 'hidden') {
        schedule();
        return;
      }
      var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      var step = cardStep();
      if (maximum < 4 || step < 1) {
        schedule();
        return;
      }
      if (track.scrollLeft >= maximum - 4) direction = -1;
      if (track.scrollLeft <= 4) direction = 1;
      var next = Math.max(0, Math.min(maximum, track.scrollLeft + (step * direction)));
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: next, behavior: 'smooth' });
      } else {
        track.scrollLeft = next;
      }
      schedule();
    }

    function setPause(reason, value, resumeDelay) {
      pause[reason] = value;
      clearTimer();
      if (!isPaused()) schedule(resumeDelay || 1800);
    }

    track.addEventListener('mouseenter', function () { setPause('hover', true); });
    track.addEventListener('mouseleave', function () { setPause('hover', false); });
    track.addEventListener('focusin', function () { setPause('focus', true); });
    track.addEventListener('focusout', function () {
      window.setTimeout(function () {
        setPause('focus', !!(document.activeElement && track.contains(document.activeElement)));
      }, 0);
    });
    track.addEventListener('pointerdown', function () { setPause('pointer', true); });
    track.addEventListener('pointerup', function () { setPause('pointer', false, 2600); });
    track.addEventListener('pointercancel', function () { setPause('pointer', false, 2600); });
    track.addEventListener('click', function (event) {
      if (Date.now() >= (track._prewornSuppressClickUntil || 0)) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
    document.addEventListener('visibilitychange', function () {
      setPause('hidden', document.visibilityState === 'hidden');
    });

    track._prewornRestartCarousel = function () {
      direction = 1;
      schedule(2200);
    };
    track._prewornRestartCarousel();
  }

  function initialiseJustBought(section) {
    if (!section || section.getAttribute('data-just-bought-ready') === 'true') return;
    section.setAttribute('data-just-bought-ready', 'true');
    bindJustBoughtCarousel(section);
    var endpoint = section.getAttribute('data-activity-endpoint');
    if (!endpoint || typeof window.fetch !== 'function') return;
    try {
      var scopedEndpoint = new URL(endpoint, window.location.href);
      var activityDepartment = departmentFocus(section);
      if (activityDepartment) scopedEndpoint.searchParams.set('department', activityDepartment);
      endpoint = scopedEndpoint.toString();
    } catch (error) {
      // Keep the theme-provided endpoint if URL parsing is unavailable.
    }
    function scheduleRefresh() {
      window.clearTimeout(section._prewornJustBoughtTimer);
      section._prewornJustBoughtTimer = window.setTimeout(function () {
        if (!section.isConnected) return;
        if (document.visibilityState === 'hidden') {
          scheduleRefresh();
          return;
        }
        requestFeed();
      }, 180000);
    }

    function requestFeed() {
      window.fetch(endpoint, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-cache',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Order activity HTTP ' + response.status);
          return response.json();
        })
        .then(function (payload) {
          if (!payload || payload.ok !== true) throw new Error('Invalid order activity response');
          renderJustBought(section, payload);
        })
        .catch(function (error) {
          var track = section.querySelector('[data-pwhome-just-bought-track]');
          if (track) track.setAttribute('aria-busy', 'false');
          console.warn('[Preworn Home] Just bought feed unavailable.', error);
        })
        .then(scheduleRefresh);
    }

    requestFeed();
  }

  function initialise(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var grids = scope.querySelectorAll('[data-pwhome-new-in-grid]');
    for (var i = 0; i < grids.length; i++) initialiseGrid(grids[i]);

    var brandSections = scope.querySelectorAll('[data-pwhome-brands]');
    for (var b = 0; b < brandSections.length; b++) initialiseBrandSection(brandSections[b]);

    var activitySections = scope.querySelectorAll('[data-pwhome-just-bought]');
    for (var a = 0; a < activitySections.length; a++) initialiseJustBought(activitySections[a]);

    if (scope.matches && scope.matches('[data-pwhome-new-in-grid]')) {
      initialiseGrid(scope);
    }
    if (scope.matches && scope.matches('[data-pwhome-brands]')) {
      initialiseBrandSection(scope);
    }
    if (scope.matches && scope.matches('[data-pwhome-just-bought]')) {
      initialiseJustBought(scope);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pwhome-new-in-category]');
    if (!button) return;
    var filterRail = button.closest('[data-pwhome-new-in-filters]');
    var section = button.closest('[data-section-id]');
    var grid = section ? section.querySelector('[data-pwhome-new-in-grid]') : null;
    activateFilterButton(grid, filterRail, button, event);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  } else {
    initialise(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target);
  });
})();
